import React, { useState, useEffect, useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import DeleteModal from "../../components/common/deleteModal";
import { Card, CardBody, Container, Row } from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import Widgets from "../dashboard/widgets";
import { useFormik } from "formik";
import * as Yup from "yup";
import { validationMessages } from "../../utils/helpers/validationMasseges";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  addResource,
  configurationCountData,
  listOfConfiguration,
} from "../../api/resourcesApi";
import TableContainer from "../../components/common/tableContainer";
import Loader from "../../components/common/loader";
import { getId } from "../../utils/helpers/custom";
import { ResponseStatusEnum, NO_DATA_FOUND } from "../../utils/helpers/enums";
import NoResultsMessage from "../../components/noResultMessage";
import {
  checkStatusCodeSuccess,
  CommonLabel,
  dateFormat,
  GBSuffix,
  HandleResponse,
  RupeeSymbol,
} from "../../utils/helpers/common";
import { ResourceLabel, Resources } from "../../common/constant/Resource";
import BaseButton from "../../components/BaseComponents/BaseButton";
import BaseModal from "../../components/BaseComponents/BaseModal";

const DamageDevice = () => {
  document.title = ResourceLabel.Configuration;
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalTodo, setModalTodo] = useState(false);
  const [todo, setTodo] = useState(null);
  const [configurationData, setConfigurationData] = useState([]);
  const [detail, setDetail] = useState(null);
  const [modalDetail, setModalDetail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);
  const [viewConfigurationData, setViewConfigurationData] = useState(null);
  const [configCardData, setConfigCardData] = useState();
  const [detailView, setDetailView] = useState(null);
  const [modalDetailedView, setModalDetailedView] = useState(false);
  const navigate = useNavigate();

  const handleDeleteTodo = () => {
    if (todo) {
      setDeleteModal(false);
    }
  };

  const amountRegex = /^\d+$/;

  const toggle = useCallback(() => {
    if (modalTodo) {
      setModalTodo(false);
      setTodo(null);
    } else {
      setModalTodo(true);
    }
  }, [modalTodo]);

  //detailed view
  const detailViewToggle = useCallback(() => {
    if (modalDetailedView) {
      setModalDetailedView(false);
      setDetailView(null);
    } else {
      setModalDetailedView(true);
    }
  }, [detailView]);

  const detailedView = (data) => {
    console.log('data check',data);
    
    setDetailView("");
    setModalDetailedView(!modalDetailedView);
    detailViewToggle();
    setViewConfigurationData(data);
  };

  const fetchData = () => {
    setTableLoader(true);
    listOfConfiguration({})
      .then((resp) => {
        setConfigurationData(resp?.data?.data);
      })
      .catch((err) => err)
      .finally(() => {
        setTableLoader(false);
      });
    };
    const fetchCardData = () => {
      setLoading(true);
      configurationCountData()
        .then((response) => {
          setConfigCardData(response?.data?.data);
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
  }
  useEffect(() => {
    fetchData();
    fetchCardData();
  }, []);

  const QueryColumns = useMemo(() => [
    {
      Header: CommonLabel.SrNo,
      Cell: ({ row }) => {
        const index = row?.index + 1;
        return <div>{index}</div>;
      },
    },
    {
      Header: ResourceLabel.BrandName,
      accessor: "brand",
      Cell: (item) => {
        return <div>{item?.cell?.row?.original?.brand || HandleResponse.NoData}</div>;
      },
      filterable: false,
    },
    {
      Header: ResourceLabel.Resource,
      accessor: "resourceName",
      Cell: (item) => {
        return (
          <div>{item?.cell?.row?.original?.resourceName || HandleResponse.NoData}</div>
        );
      },
      filterable: false,
    },
    {
      Header: ResourceLabel.ResourceNo,
      accessor: "resourceNo",
      Cell: (item) => {
        return (
          <div>{item?.cell?.row?.original?.resourceNo || HandleResponse.NoData}</div>
        );
      },
      filterable: false,
    },
    {
      Header: ResourceLabel.Vendor,
      accessor: "business",
      Cell: (item) => {
        return (
          <div>
            {item?.cell?.row?.original?.vendor?.business || HandleResponse.NoData}
          </div>
        );
      },
      filterable: false,
    },
    {
      Header: ResourceLabel.PurchaseDate,
      accessor: "purchaseDate",
      Cell: (cell) => {
        const date = cell?.row?.original?.purchaseDate;
        return (
          <div>
            {dateFormat(date) !== CommonLabel.InvalidDate
              ? dateFormat(date)
              : HandleResponse.NoData}
          </div>
        );
      },
      filterable: false,
    },
    {
      Header: ResourceLabel.WarrantyEndDate,
      accessor: "warrantyEndDate",
      Cell: (cell) => {
        const date = cell?.row?.original?.warrantyEndDate;
        return (
          <div>
            {dateFormat(date) !== CommonLabel.InvalidDate
              ? dateFormat(date)
              : HandleResponse.NoData}
          </div>
        );
      },
      filterable: false,
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps, key, items) => {
        return (
          <div className="hstack gap-2">
            <Link
              id={`editAction-${cellProps.row.index}`}
              className="btn btn-sm btn-soft-info edit-list"
              to={`/configuration/editConfiguration/${cellProps.row.original.id}`}
            >
              <i className="ri-pencil-fill align-bottom" />
            </Link>
            <ReactTooltip
              place="bottom"
              variant="info"
              content={CommonLabel.Update}
              anchorId={`editAction-${cellProps.row.index}`}
            />
            {cellProps?.cell?.row?.original?.resourceName === "Laptop" && (
              <div className="hstack gap-2">
                <Link
                  id={`detailedView-${cellProps.row.index}`}
                  className="btn btn-sm btn-soft-info"
                  onClick={() => {
                    detailedView(cellProps.row.original);
                  }}
                >
                  <i className="ri-booklet-line align-bottom" />
                </Link>
                <ReactTooltip
                  place="bottom"
                  variant="info"
                  content={CommonLabel.View}
                  anchorId={`detailedView-${cellProps.row.index}`}
                />
              </div>
            )}
          </div>
        );
      },
    },
  ]);

  const WidgetData = [
    {
      id: 1,
      cardColor: "primary",
      label: "Available Devices",
      badgeClass: "success",
      badge: "ri-arrow-right-up-line",
      percentage: configCardData?.availableResourcesData,
      counter: configCardData?.availableResourcesData,
      bgcolor: "success",
      icon: "bx bx-devices",
      decimals: 0,
      prefix: "",
      suffix: "",
      link: "/filter-resource",
    },
    {
      id: 1,
      cardColor: "primary",
      label: "Allocated Devices",
      badgeClass: "success",
      badge: "ri-arrow-right-up-line",
      percentage: configCardData?.totalAllocatedDevicesOfCurrentMonthData,
      counter: configCardData?.totalAllocatedDevicesData,
      bgcolor: "success",
      icon: "bx bx-devices",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: 1,
      cardColor: "primary",
      label: "Damaged Devices",
      badgeClass: "success",
      badge: "ri-arrow-right-up-line",
      percentage: configCardData?.totalDamageDevicesData,
      counter: configCardData?.totalDamageDevicesData,
      bgcolor: "success",
      icon: "bx bx-devices",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
    {
      id: 1,
      cardColor: "primary",
      label: "Total Devices",
      badge: "ri-arrow-right-up-line",
      badgeClass: "success",
      percentage: configCardData?.totalDevicesOfCurrentMonthData,
      counter: configCardData?.totalDevicesData,
      bgcolor: "success",
      icon: " bx bx-navigation",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
  ];
  const InfoRow = ({ label, value }) => (
    <div className="col-6 mb-2">
      <strong>{label}:</strong> {value}
    </div>
  );
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => handleDeleteTodo()}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={ResourceLabel.Configuration} pageTitle="HRMS" />
          <Row className="mb-2">
            <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
              <h5 className="fw-semibold mt-2">
                {ResourceLabel.Configuration}
              </h5>
            </div>

            <div className="col-auto order-2 order-sm-3 ms-auto">
              <div className="hstack gap-2">
                <BaseButton
                  color="primary"
                  type="button"
                  onClick={() => navigate("/configuration/addConfiguration")}
                >
                  <i className="ri-add-line mt-2" />
                  {ResourceLabel.Configuration}
                </BaseButton>
              </div>
            </div>
          </Row>
          <Row className="relative-container">
            {loading === false ? (
              <Widgets data={WidgetData} />
            ) : (
              <div className="loader-container">
                <Loader />
              </div>
            )}
          </Row>
          <Card>
            <CardBody>
              {configurationData?.length || tableLoader ? (
                <TableContainer
                  columns={QueryColumns}
                  data={configurationData}
                  isAddUserList={false}
                  customPageSize={5}
                  isGlobalFilter={false}
                  tableLoader={tableLoader}
                  divClass="table-responsive table-card mb-1"
                  tableClass="align-middle table-nowrap"
                  theadClass="table-light text-muted"
                />
              ) : (
                <NoResultsMessage />
              )}
            </CardBody>
          </Card>
        </Container>
        <BaseModal
          open={modalDetailedView}
          size="xl"
          onClose={() => setModalDetailedView(false)}
          toggle={() => setModalDetailedView(false)}
          className="zoomIn"
          title={ResourceLabel.LaptopDetail}
          bodyClassName="p-4"
          closeLabel={CommonLabel.Close}
          closeLabelColor="ghost-success"
        >
          <div className="px-4">
            <h5 className="mb-2 text-lg font-semibold">
              {ResourceLabel.GeneralInformation}
            </h5>
            <div className="row">
              <InfoRow label={ResourceLabel.ResourceName} value={viewConfigurationData?.resourceName} />
              <InfoRow label={ResourceLabel.ResourceNo} value={viewConfigurationData?.resourceNo} />
              <InfoRow label={ResourceLabel.BrandName} value={viewConfigurationData?.brand} />
              <InfoRow label={ResourceLabel.Amount} value={RupeeSymbol(viewConfigurationData?.amount)} />
              <InfoRow label={ResourceLabel.PaymentMode} value={viewConfigurationData?.paidBy} />
              <InfoRow label={ResourceLabel.PurchaseDate} value={viewConfigurationData?.purchaseDate} />
              <InfoRow
                label={ResourceLabel.Warranty}
                value={`${viewConfigurationData?.warrantyStartDate} - ${viewConfigurationData?.warrantyEndDate}`}
              />
              <InfoRow label={ResourceLabel.Vendor} value={viewConfigurationData?.vendor.business} />
            </div>
            <hr className="my-4" />

            <h5 className="mb-2 text-lg font-semibold">
              {ResourceLabel.ConfigurationDetail}
            </h5>
            <div className="row">
              <InfoRow
                label={ResourceLabel.PCModalName}
                value={viewConfigurationData?.resourceConfiguration.modelName}
              />
              <InfoRow
                label={ResourceLabel.PCSerialNo}
                value={viewConfigurationData?.resourceConfiguration.serialNo}
              />
              <InfoRow
                label={ResourceLabel.Processor}
                value={viewConfigurationData?.resourceConfiguration.processor}
              />
              <InfoRow
                label={ResourceLabel.Ram}
                value={GBSuffix(viewConfigurationData?.resourceConfiguration.RAM)}
              />
              <InfoRow
                label={ResourceLabel.StorageType}
                value={viewConfigurationData?.resourceConfiguration.storageType}
              />
              <InfoRow
                label={ResourceLabel.OsType}
                value={viewConfigurationData?.resourceConfiguration.osType}
              />
              <InfoRow
                label={ResourceLabel.OsVersion}
                value={viewConfigurationData?.resourceConfiguration.osVersion}
              />
              <InfoRow
                label={ResourceLabel.GraphicCard}
                value={GBSuffix(viewConfigurationData?.resourceConfiguration.graphicsCard)}
              />
            </div>
          </div>

        </BaseModal>
      </div>
    </React.Fragment>
  );
};

export default DamageDevice;
